type Params = Record<string, string>;

export const setParams = (params: Params): void => {
  const url = new URL(location?.href);

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  history?.pushState({}, "", url);
};
